<!--树形选择
	imgMethod:图标获取的方法，传回项，返回图片路径
	dataList:数据列表
	nowCheckId:当前选中的尾段节点的id,这个树是单选的
	getIdMethod:获取id的方法,返回一个唯一的字符串
	menuCheckedAble:是否允许选中菜单项,默认不允许
	margin:进行子集margin-left操作
	firstStageClass：第一级菜单加样式的暂时想法，第一级只有一个可以这样做，多个就会有问题，需要这个prop来确认是否开启样式
-->
<template>
	<div class="oldTreeBody">
		<!-- :style="$store.resourcesStore.getters.getBackgroudImageStyle('tree/unitdefect_right.png')" -->
		<div class="treeItem" v-for="(item,index) in dataList" v-if="isEnable(item)" :key="index">
			<div :class="['tree-column',{'oldTreeChecked':getDivStyle(item)}]" @click.stop="checkItem(item,index)" :key="getIdMethod(item)">
				<img :style="getStyle(item)" class="state" :src="getStateImg(item)" alt="" />
				<img v-if="checkedShow" :src="getCheckedImg(item)" alt="" />
				<img class="tips" :src="imgMethod(item)" alt="" />
				<span>{{getName(item)}}</span>
			</div>
			<tree :checked="checked" :margin="marginLeft+10" :imgMethod="imgMethod" :getIdMethod="getIdMethod" :nowOpenFloorIds="nowOpenFloorIds"
			 :nowCheckId="nowCheckId" :menuCheckedAble="menuCheckedAble" :dataList='item.next' v-if="hasNext(item)" v-show="isCheck(item)"
			 @checkItem="threadCheck" :getEnableMethod="getEnableMethod" :getNameMethod="getNameMethod"></tree>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		name: 'tree',
		components: {},
		props: {
			margin: {
				type: Number,
			},
			imgMethod: {
				type: Function,
				default () {}
			},
			dataList: {
				type: Array,
				default: []
			},
			nowCheckId: {
				type: String,
			},
			nowOpenFloorIds: {
				type: Array,
				default: []
			},
			getIdMethod: {
				type: Function,
				default (item) {
					return item.id
				}
			},
			getNameMethod: {
				type: Function,
				default (item) {
					return item.name
				}
			},
			getEnableMethod: {
				type: Function,
				default (item) {
					return true
				}
			},
			menuCheckedAble: {
				type: Boolean,
				default: false
			},
			checked: {
				type: Boolean,
				default: false
			},
			hasNext: {
				type: Function,
				default (item) {
					if (item.next == undefined) {
						return false
					}
					//过滤掉不可用的
					if (this.getEnableMethod != undefined) {
						var enableList = item.next.filter(item => {
							return this.getEnableMethod(item)
						})
						if (enableList.length == 0) {
							return false
						}
					}
					return true
				}
			}
		},
		data() {
			return {
				marginLeft: 0
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getColorById() {
				return id => {
					return resourcesStore.getters.getColorById(id)
				}
			},
			checkedShow() {
				if (undefined == this.checked) {
					return false
				}
				return this.checked
			},
			getCheckedImg() {
				return item => {
					if (item.type == 'unit' || item.entityName == 'AppClassType') {
						return
					}
					if (this.getIdMethod(item) == undefined) {
						return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
					}
					if (this.nowCheckId == this.getIdMethod(item)) {
						return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
					}
					return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
				}
			},
			getDivStyle() {
				return item => {
					if (this.getIdMethod == undefined) {
						return false
					}
					if (this.nowCheckId == this.getIdMethod(item)) {
						return true
					}
					return false
				}
			},
			getStyle() {
				this.getMargin()
				return item => {
					if (this.getIdMethod == undefined) {
						return
					}
					if (this.nowCheckId == this.getIdMethod(item)) {
						return {
							'margin-left': this.marginLeft + "px",
							color: '#2A82DE',
						}
					}
					return {
						'margin-left': this.marginLeft + "px"
					}
				}
			},
			isCheck() {
				return item => {
					return this.nowOpenFloorIds.includes(this.getIdMethod(item))
				}
			},
		},
		watch: {},
		methods: {
			getMargin() {
				if (undefined == this.margin) {
					this.marginLeft = 10
				} else {
					this.marginLeft = this.margin
				}
			},
			getStateImg(item) {
				if (this.hasNext(item)) {
					return this.isCheck(item) ? resourcesStore.getters.getResourcesByName("tree/tree_open.png") : resourcesStore.getters
						.getResourcesByName("tree/tree_close.png")
				}
				return resourcesStore.getters.getResourcesByName("tree/tree_none.png")
			},
			checkItem(item, index) {
				// this.$store.userStore.commit('setCompanyId',item.id)
				// console.log("item",item);
				if (item.entityName == 'Page') {
					//如果是单独项就一级级上抛
					this.$emit("checkItem", item)
					return
				}
				var id = this.getIdMethod(item)
				var i = this.nowOpenFloorIds.indexOf(id)
				if (i == -1) {
					//选中了某项
					this.nowOpenFloorIds.push(id)
				} else {
					//取消了某项的选中
					this.nowOpenFloorIds.splice(i, 1)
				}
				if (this.menuCheckedAble == true) {
					//菜单也能选中的
					this.$emit("checkItem", item)
				}
			},
			threadCheck(item) {
				this.$emit("checkItem", item)
			},
			getName(item) {
				if (this.getNameMethod != undefined) {
					return this.getNameMethod(item)
				}
				return item.name
			},
			isEnable(item) {
				if (this.getEnableMethod != undefined) {
					return this.getEnableMethod(item)
				}
				return true
			}
		}
	}
</script>

<style scoped>
	.tree-column {
		height: 38px;
		line-height: 38px;
		padding-right: 20px;
	}

	.oldTreeBody {
		height: 100%;
		width: 100%;
		color: white;
	}

	.treeItem {
		white-space: nowrap;
		cursor: pointer;
	}

	.treeItem img.state {
		width: .1rem;
		height: .1rem;
		margin-left: 15px;
	}

	.treeItem img.tips {
		width: .15rem;
		height: .15rem;
		margin-left: 5px;
	}

	.treeItem span {
		white-space: nowrap;
		line-height: .2rem;
		padding-left: .1rem;
		color: black;
	}
</style>
